import Vue from "vue";

import { Button, NavBar, Swipe, SwipeItem, Lazyload, Toast   } from "vant";

const components = [Button, NavBar, Swipe, SwipeItem, Lazyload,Toast ];


components.map((v) => {
  return Vue.use(v);
});
